import { SubjectCreatePage } from "@/features/learning-content/pages/SubjectCreate";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const SubjectCreate: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <SubjectCreatePage />
      </Box>
    </Stack>
  );
};

export default SubjectCreate;
